import React from 'react';
import './home_about.css';
import { Link } from 'react-router-dom';
import RollingShowcase from '../../components/RollingShowcase';
const HomeAboutFramSys = () => {
  return (
    <div className='home-about'>
      <h1>Welcome to FramSys!</h1>
      <div className="text-content">
       <p className="p">
        FramSys is a Åland Island based AI and Software solutions company
        </p>
        <p className="p">
          We specialise in applied solutions that enable you to work more effectively 
          and make better decisions based on real world data.
        </p>
      </div>
          <RollingShowcase 
                        speed={40} 
                        images={[

                            require('../../assets/dashboard_images/7.png'),
                            require('../../assets/dashboard_images/6.png'),
                            require('../../assets/dashboard_images/5.png'),
                            require('../../assets/dashboard_images/4.png'),
                            require('../../assets/dashboard_images/3.png'),
                            require('../../assets/dashboard_images/2.png'),
                            require('../../assets/dashboard_images/1.png'),


                        ]} 
                        className="row-4" 
                    />


      <p className='small-text'>
        For more information, see our       <Link to="/metric_generator" className="link">Metric Generator</Link>     
      </p>

    </div>
  );
};

export default HomeAboutFramSys;